/** ワークフロー連携の URL クエリパラメータ名 (`workflow.md` の遷移 URL `?workflowId={id}`)。 */
export const WORKFLOW_ID_PARAM = 'workflowId'

/**
 * 改名前のパラメータ名。8/24 リリース後に作られたブックマーク・共有 URL・
 * 開いたままのタブが `?caseId=` を持つため、読み取りだけ受け付ける。
 * URL の組み立てには使わない (#9601)。
 */
const LEGACY_CASE_ID_PARAM = 'caseId'

/**
 * URL クエリパラメータから workflowId を解決する。`?workflowId=` を優先し、
 * 無い時だけ旧 `?caseId=` を読む。空文字は未指定と同じ扱い。
 *
 * ワークフロー連携のパラメータ読み取りはこの関数に一本化する (画面ごとに
 * `searchParams.get` しない)。画面は `useCurrentWorkflowCase` か
 * `useWorkflowCaseIdParam` 経由で読み、`PlaceholderPage` だけが本関数を直接使う。
 */
export function resolveWorkflowIdParam(
  searchParams: URLSearchParams,
): string | undefined {
  for (const key of [WORKFLOW_ID_PARAM, LEGACY_CASE_ID_PARAM]) {
    const value = searchParams.get(key)
    if (value !== null && value !== '') {
      return value
    }
  }
  return undefined
}
